import { render } from "./statusBar.vue?vue&type=template&id=395dd128&scoped=true"
import script from "./statusBar.vue?vue&type=script&lang=js"
export * from "./statusBar.vue?vue&type=script&lang=js"

import "./statusBar.vue?vue&type=style&index=0&id=395dd128&scoped=true&lang=css"
/* custom blocks */
import block0 from "./statusBar.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395dd128"]])

export default __exports__